let step = 1;     
let question = 1; 

function getMainStep() {
  if (step >= 1 && step <= 5) return 1; 
  if (step === 6) return 2;             
  if (step === 7) return 3;             
  if (step === 8) return 4;           
}

function updateProgress() {
  const mainStep = getMainStep();
  let percent = ((mainStep - 1) / 3) * 100;
  if (mainStep === 1) {
    if (step === 1 ) {
        percent = 0;          
      } 
      else if (step == 2) {
    percent = 6;
  }
  else if (step == 3) {
    percent = 12;
  }
  else if (step == 4) {
    percent = 18;
  }
  else if (step == 5) {
    percent = 24;
  }
  else {
        percent = 15 + ((question - 2) / 4) * 15; 
    }
  }
  $("#progress-bar").css("width", percent + "%");
  $("#step-indicator span").each(function (i) {
    $(this).toggleClass("active", i + 1 === mainStep);
  });
  const spans = $("#step-indicator span");
  spans.removeClass("before-active"); 
  const activeIndex = mainStep - 1; 
  for (let i = activeIndex - 1; i >= 0; i--) {
    $(spans[i]).addClass("before-active");
  }
}

function update() {
  $(".step").removeClass("active");
  $(`.step[data-step="${step}"]`).addClass("active");
  updateProgress();
}

function next() {
  const sec = $(`.step[data-step="${step}"]`);
  const req = sec.find("input[required]");
  let valid = true;

  req.each(function () {
    if (!$(this).is(":checked")) valid = false;
  });

  if (!valid) {
    alert("Please select an option.");
    return;
  }
  step++;
  update();
}


function back() {
  if (step > 1) step--;
  // const prevSec = $(`.step[data-step="${step}"]`);
  // prevSec.find("input[type='radio'], input[type='checkbox']").prop("checked", false);
  update();
}

update();



$(document).ready(function () {
  $('input[name="concern"]').on("change", function () {
    let val = $(this).val().toLowerCase().replace(/\s+/g, "-");
    $(".steps").hide();
    $(`.steps[data-linked="${val}"]`).show();
  });
  $(document).on("change", "label.card-option input[type='radio']", function () {
    next();
  });  
});
